export default "__VITE_ASSET__bfd7f2e2__"